import React from "react";

function TextError(props) {
  return (
    <div
      style={{
        color: "red",
        fontSize: "0.8rem",
        textAlign: "left",
        marginTop: "0.3rem",
      }}
    >
      {props.children}
    </div>
  );
}

export default TextError;
